import React, { useState, useEffect, useMemo, useRef } from 'react';
import { GiHamburgerMenu } from "react-icons/gi";
import { IoClose, IoCall } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { RiAccountCircleLine } from "react-icons/ri";
import { BiLogOutCircle } from "react-icons/bi";
import { FaHeadphonesAlt } from "react-icons/fa";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logostelmart from '../../assets/images/logostelmart.png';
import LoginModal from '../LoginModal/LoginModal';
import { getAuthToken, removeAuthToken, getUserData } from "../../utils/auth";
import '../../components/Header/Header.css';
import '../../styles/CustomClassCss/Custom.css';
import { CiSettings } from "react-icons/ci";
import { LuBriefcaseBusiness } from 'react-icons/lu';
import { IoLocationOutline } from 'react-icons/io5';
import { FaChevronDown, FaChevronUp, FaChevronRight } from "react-icons/fa";
import { getCategoriesMenu } from '../../API/Api';

const Header = () => {
	const categoriesDropdownRef = useRef(null);
	const profileDropdownRef = useRef(null);
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);
	const [isPopupOpen, setIsPopupOpen] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
	const [token, setToken] = useState(null);
	const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);
	const [openSubMenu, setOpenSubMenu] = useState(null);
	const [openSubSubMenu, setOpenSubSubMenu] = useState(null);

	const [user, setUser] = useState(null);
	const storedUserData = useMemo(() => getUserData(), []);
	const navigate = useNavigate();
	const location = useLocation();
	const currentPath = location.pathname;
	const [categoriesData, setCategoriesData] = useState([]);
	const [loadingCategories, setLoadingCategories] = useState(false);
	const [categoriesError, setCategoriesError] = useState(null);

	useEffect(() => {
		setToken(getAuthToken());
	}, [isModalOpen, location]);


	const handleHelpSupportClick = () => {
		navigate('/contact-us');
		setIsPopupOpen(false);
	};


	const toggleSidebar = () => {
		setIsSidebarOpen(!isSidebarOpen);
	};

	const togglePopup = () => {
		setIsPopupOpen(!isPopupOpen);
	};

	const toggleModal = () => {
		if (window.innerWidth <= 768) {
			setIsSidebarOpen(false);
		}
		setIsModalOpen(!isModalOpen);
	};

	const toggleProfileMenu = () => {
		setIsProfileMenuOpen(!isProfileMenuOpen);
	};

	const handleCategoriesMouseLeave = () => {
		setTimeout(() => {
			if (
				!categoriesDropdownRef.current?.matches(':hover') &&
				!document.querySelector('.submenu:hover') &&
				!document.querySelector('.subsubmenu:hover')
			) {
				setIsCategoriesOpen(false);
				setOpenSubMenu(null);
				setOpenSubSubMenu(null);
			}
		}, 200);
	};

	const handleSubMenuMouseLeave = () => {
		setTimeout(() => {
			if (!document.querySelector('.submenu:hover') && !document.querySelector('.subsubmenu:hover')) {
				setOpenSubMenu(null);
				setOpenSubSubMenu(null);
			}
		}, 200);
	};

	const handleSubSubMenuMouseLeave = () => {
		setTimeout(() => {
			if (!document.querySelector('.subsubmenu:hover')) {
				setOpenSubSubMenu(null);
			}
		}, 200);
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				categoriesDropdownRef.current &&
				!categoriesDropdownRef.current.contains(event.target)
			) {
				setIsCategoriesOpen(false);
				setOpenSubMenu(null);
				setOpenSubSubMenu(null);
			}
			if (
				profileDropdownRef.current &&
				!profileDropdownRef.current.contains(event.target)
			) {
				setIsProfileMenuOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleLogout = () => {
		removeAuthToken();
		setToken(null);
		setIsSidebarOpen(false);
		setIsProfileMenuOpen(false);
		toast.success("Logged out successfully");
		setTimeout(() => {
			window.location.href = "/";
		}, 300);
	};

	const isActiveLink = (path) => currentPath === path ? 'active' : '';

	useEffect(() => {
		const fetchCategories = async () => {
			try {
				setLoadingCategories(true);
				const data = await getCategoriesMenu();
				setCategoriesData(data);
				setLoadingCategories(false);
			} catch (error) {
				setCategoriesError(error);
				setLoadingCategories(false);
			}
		};

		fetchCategories();
	}, []);

	const getUserInitials = (firstName, lastName) => {
		let initials = '';
		if (firstName?.trim()) initials += firstName.trim()[0].toUpperCase();
		if (lastName?.trim()) initials += lastName.trim()[0].toUpperCase();
		return initials || 'U';
	};

	const renderSubSubMenu = (subsubcategories, parentUrl) => {
		return (
			<div
				className="subsubmenu"
				onMouseEnter={() => setOpenSubSubMenu(parentUrl)}
				onMouseLeave={handleSubSubMenuMouseLeave}
			>
				{subsubcategories.map((subsubcategory) => (
					<Link
						key={subsubcategory.id}
						to={`/categories/${subsubcategory.url}`}
						className="submenu-item"
						onClick={() => {
							setIsCategoriesOpen(false);
							setOpenSubMenu(null);
							setOpenSubSubMenu(null);
						}}
					>
						{subsubcategory.name}
					</Link>
				))}
			</div>
		);
	};

	return (
		<nav className="header">
			<div className="header-container custom-container-side">
				<div className="header-left">
					<div className="header-logo">
						<Link to="/">
							<img src={logostelmart} alt="Logo Stelmart" />
						</Link>
					</div>
				</div>

				<div className="header-hamburger">
					<GiHamburgerMenu className="hamburger-icon" onClick={toggleSidebar} />
				</div>

				<div className="header-center font-poppins">
					<ul className="header-links">
						<li><Link to="/" className={isActiveLink('/')}>HOME</Link></li>
						<li><Link to="/about-us" className={isActiveLink('/about-us')}>ABOUT US</Link></li>
						<li
							className="nav-item dropdown"
							ref={categoriesDropdownRef}
							onMouseEnter={() => setIsCategoriesOpen(true)}
							onMouseLeave={handleCategoriesMouseLeave}
						>
							<div
								className={`nav-link header-links dropdown-toggle space-header${isActiveLink('/categories')}`}
								onClick={(e) => {
									e.stopPropagation();
									setIsCategoriesOpen(!isCategoriesOpen);
								}}
							>
								CATEGORIES{' '}
								{isCategoriesOpen ? (
									<FaChevronUp className="dropdown-icon-c" />
								) : (
									<FaChevronDown className="dropdown-icon-c" />
								)}
							</div>

							{isCategoriesOpen && (
								<div
									className="dropdown-menu-c"
									onMouseEnter={() => setIsCategoriesOpen(true)}
									onMouseLeave={handleCategoriesMouseLeave}
								>
									{(loadingCategories || categoriesError) ? (
										<div className="dropdown-item-c"></div>
									) : (
										categoriesData.map((category) => (
											<div
												key={category.id}
												className={`dropdown-item-c ${category.subcategories.length ? 'with-submenu' : ''}`}
												onClick={() => {
													if (!category.subcategories.length) {
														navigate(`/categories/${category.url}`);
														setIsCategoriesOpen(false);
													}
												}}
												onMouseEnter={() => {
													if (category.subcategories.length) {
														setOpenSubMenu(category.id);
													}
												}}
												onMouseLeave={() => {
													if (category.subcategories.length && !document.querySelector('.submenu:hover')) {
														setOpenSubMenu(null);
													}
												}}
											>
												<div className="submenu-container">
													{category.name}
													{category.subcategories.length > 0 && (
														<FaChevronRight className="submenu-icon" />
													)}
												</div>

												{openSubMenu === category.id && category.subcategories.length > 0 && (
													<div
														className="submenu"
														onMouseEnter={() => setOpenSubMenu(category.id)}
														onMouseLeave={handleSubMenuMouseLeave}
													>
														{category.subcategories.map((subcategory) => (
															<div
																key={subcategory.id}
																className={`submenu-item ${subcategory.subcategories?.length ? 'with-subsubmenu' : ''}`}
																onClick={(e) => {
																	if (!subcategory.subcategories?.length) {
																		navigate(`/categories/${subcategory.url}`);
																		setIsCategoriesOpen(false);
																		setOpenSubMenu(null);
																	} else {
																		e.stopPropagation();
																	}
																}}
																onMouseEnter={() => {
																	if (subcategory.subcategories?.length) {
																		setOpenSubSubMenu(subcategory.id);
																	}
																}}
																onMouseLeave={() => {
																	if (subcategory.subcategories?.length && !document.querySelector('.subsubmenu:hover')) {
																		setOpenSubSubMenu(null);
																	}
																}}
															>
																<div className="subsubmenu-container">
																	{subcategory.name}
																	{subcategory.subcategories?.length > 0 && (
																		<FaChevronRight className="subsubmenu-icon" />
																	)}
																</div>
																{openSubSubMenu === subcategory.id && subcategory.subcategories?.length > 0 && (
																	renderSubSubMenu(subcategory.subcategories, subcategory.id)
																)}
															</div>
														))}
													</div>
												)}
											</div>
										))
									)}
								</div>
							)}
						</li>
						<li><Link to="/financial-services" className={isActiveLink('/financial-services')}>FINANCIAL SERVICES</Link></li>
						<li><Link to="/blogs" className={isActiveLink('/blogs')}>BLOGS</Link></li>
						<li><Link to="/faqs" className={isActiveLink('/faqs')}>FAQ</Link></li>
						{token && <li><Link to="/dashboard" className={isActiveLink('/dashboard')}>DASHBOARD</Link></li>}
					</ul>
				</div>

				<div className="header-right">
					{token ? (
						<div className="profile-container">
							<div className="profile-menu">
								<div className="menu-icon" onClick={toggleProfileMenu}>
									<div className="menu-line"></div>
									<div className="menu-line"></div>
									<div className="menu-line"></div>
								</div>

								<div className="profile-image">
									{storedUserData?.image ? (
										<img src={storedUserData.image} alt="User" className="user-avatar" />
									) : (
										<div className="user-initials-header">
											{getUserInitials(storedUserData?.name, '')}
										</div>
									)}
									<span className="alert-badge">!</span>
								</div>
							</div>
							{isProfileMenuOpen && (
								<div className="profile-dropdown" ref={profileDropdownRef}>
									{storedUserData?.userType === 'seller' ? (
										<Link
											to="/seller-business"
											onClick={() => setIsProfileMenuOpen(false)}
											className={isActiveLink('/seller-business')}
											style={currentPath === '/seller-business' ? { color: '#ffba00' } : {}}
										>
											<LuBriefcaseBusiness className="icon" />
											Seller Business
										</Link>
									) : (
										<Link
											to="/business"
											onClick={() => setIsProfileMenuOpen(false)}
											className={isActiveLink('/business')}
											style={currentPath === '/business' ? { color: '#ffba00' } : {}}
										>
											<LuBriefcaseBusiness className="icon" />
											My Business
										</Link>
									)}
									<Link
										to="/address"
										onClick={() => setIsProfileMenuOpen(false)}
										className={isActiveLink('/address')}
										style={currentPath === '/address' ? { color: '#ffba00' } : {}}
									>
										<IoLocationOutline className="icon" />
										My Address
									</Link>
									<Link
										to="/setting"
										onClick={() => setIsProfileMenuOpen(false)}
										className={isActiveLink('/setting')}
										style={currentPath === '/setting' ? { color: '#ffba00' } : {}}
									>
										<CiSettings className="icon" />
										Settings
									</Link>
									<Link to="/" onClick={handleLogout}>
										<BiLogOutCircle className="icon" />
										Logout
									</Link>
								</div>
							)}
						</div>
					) : (
						<Link
							to="/contact"
							className="header-contact font-merriweather"
							onClick={(e) => {
								e.preventDefault();
								togglePopup();
							}}
						>
							GET IN TOUCH
						</Link>
					)}
				</div>
			</div>

			{isSidebarOpen && (
				<div className="sidebar">
					<IoClose className="close-sidebar-icon" onClick={toggleSidebar} />
					<ul className="sidebar-links">
						<li><Link to="/" className={isActiveLink('/')} onClick={toggleSidebar}>HOME</Link></li>

						<li><Link to="/categories" className={isActiveLink('/categories')} onClick={toggleSidebar}>CATEGORIES</Link></li>
						<li><Link to="/about-us" className={isActiveLink('/about-us')} onClick={toggleSidebar}>ABOUT US</Link></li>
						<li><Link to="/financial-services" className={isActiveLink('/financial-services')} onClick={toggleSidebar}>FINANCIAL SERVICES</Link></li>
						<li><Link to="/blogs" className={isActiveLink('/blogs')} onClick={toggleSidebar}>BLOGS</Link></li>
						<li><Link to="/faqs" className={isActiveLink('/faqs')} onClick={toggleSidebar}>FAQ</Link></li>
						{token && <li><Link to="/dashboard" className={isActiveLink('/dashboard')} onClick={toggleSidebar}>DASHBOARD</Link></li>}
						<li><Link to="#contact" className={isActiveLink('/contact')} onClick={toggleSidebar}>GET IN TOUCH</Link></li>
						{token && (
							<li className="logout" onClick={() => {
								handleLogout();
								toggleSidebar();
							}}>
								<BiLogOutCircle className="icon" />
								LOGOUT
							</li>
						)}
					</ul>
					{token && (
						<div className="sidebar-login-register">
							<Link to="/dashboard" className="navbar-login font-poppins" onClick={toggleSidebar}>
								<RiAccountCircleLine className="navbar-icon" />
								MY ACCOUNT
							</Link>
						</div>
					)}
					{!token && (
						<div className="sidebar-login-register">
							<button className="navbar-login font-poppins" onClick={() => {
								toggleModal();
								toggleSidebar();
							}}>
								<RiAccountCircleLine className="navbar-icon" />
								Login/Register
							</button>
						</div>
					)}
				</div>
			)}

			<LoginModal
				isOpen={isModalOpen}
				onClose={toggleModal}
				onLoginSuccess={() => {
					setToken(getAuthToken());
					setIsModalOpen(false);
				}}
			/>

			{isPopupOpen && (
				<div className="popup">
					<div className="popup-content">
						<IoClose className="close-popup-icon" onClick={togglePopup} />
						<h2 className="popup-title font-merriweather"> <FaHeadphonesAlt /> Connect with us</h2>
						<div className="contact-card">
							<div className="contact-item">
								<div className="contact-icon-circle">
									<IoCall className="contact-icon" />
								</div>
								<div className="contact-details font-lato">
									<p className="contact-title">Call us</p>
									<p className="contact-info">
										<a href="tel:+917011588280">+91 7011588280</a>
									</p>
									<p className="contact-subinfo">Mon-Fri | 10am to 7pm</p>
								</div>
							</div>
							<div className="contact-item">
								<div className="contact-icon-circle">
									<MdEmail className="contact-icon" />
								</div>
								<div className="contact-details font-lato">
									<p className="contact-title">Write to us</p>
									<p className="contact-info">
										<a href="mailto:info@stelmart.co.in">info@stelmart.co.in</a>
									</p>
								</div>
							</div>
							<button className="help-support-button" onClick={handleHelpSupportClick}>
								Help & Support
							</button>               </div>
					</div>
				</div>
			)}
		</nav>
	);
};

export default Header;









// import React, { useState, useEffect, useMemo, useRef } from 'react';
// import { GiHamburgerMenu } from "react-icons/gi";
// import { IoClose, IoCall } from "react-icons/io5";
// import { MdEmail } from "react-icons/md";
// import { RiAccountCircleLine } from "react-icons/ri";
// import { BiLogOutCircle } from "react-icons/bi";
// import { FaHeadphonesAlt } from "react-icons/fa";
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import logostelmart from '../../assets/images/logostelmart.png';
// import LoginModal from '../LoginModal/LoginModal';
// import { getAuthToken, removeAuthToken, getUserData } from "../../utils/auth";
// import '../../components/Header/Header.css';
// import '../../styles/CustomClassCss/Custom.css';
// import { CiSettings } from "react-icons/ci";
// import { LuBriefcaseBusiness } from 'react-icons/lu';
// import { IoLocationOutline } from 'react-icons/io5';
// import { FaChevronDown, FaChevronUp, FaChevronRight } from "react-icons/fa";
// import { getCategoriesMenu } from '../../API/Api';

// const Header = () => {
// 	const categoriesDropdownRef = useRef(null);
// 	const profileDropdownRef = useRef(null);
// 	const [isSidebarOpen, setIsSidebarOpen] = useState(false);
// 	const [isPopupOpen, setIsPopupOpen] = useState(false);
// 	const [isModalOpen, setIsModalOpen] = useState(false);
// 	const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
// 	const [token, setToken] = useState(null);
// 	const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);
// 	const [openSubMenu, setOpenSubMenu] = useState(null);
// 	const [openSubSubMenu, setOpenSubSubMenu] = useState(null);
// 	const [isMobileView, setIsMobileView] = useState(false);

// 	const [user, setUser] = useState(null);
// 	const storedUserData = useMemo(() => getUserData(), []);
// 	const navigate = useNavigate();
// 	const location = useLocation();
// 	const currentPath = location.pathname;
// 	const [categoriesData, setCategoriesData] = useState([]);
// 	const [loadingCategories, setLoadingCategories] = useState(false);
// 	const [categoriesError, setCategoriesError] = useState(null);

// 	useEffect(() => {
// 		const handleResize = () => {
// 			setIsMobileView(window.innerWidth <= 768);
// 		};

// 		handleResize();
// 		window.addEventListener('resize', handleResize);
// 		return () => window.removeEventListener('resize', handleResize);
// 	}, []);

// 	useEffect(() => {
// 		setToken(getAuthToken());
// 	}, [isModalOpen, location]);

// 	const handleHelpSupportClick = () => {
// 		navigate('/contact-us');
// 		setIsPopupOpen(false);
// 	};

// 	const toggleSidebar = () => {
// 		setIsSidebarOpen(!isSidebarOpen);
// 	};

// 	const togglePopup = () => {
// 		setIsPopupOpen(!isPopupOpen);
// 	};

// 	const toggleModal = () => {
// 		if (window.innerWidth <= 768) {
// 			setIsSidebarOpen(false);
// 		}
// 		setIsModalOpen(!isModalOpen);
// 	};

// 	const toggleProfileMenu = () => {
// 		setIsProfileMenuOpen(!isProfileMenuOpen);
// 	};

// 	const handleCategoriesMouseLeave = () => {
// 		setTimeout(() => {
// 			if (
// 				!categoriesDropdownRef.current?.matches(':hover') &&
// 				!document.querySelector('.submenu:hover') &&
// 				!document.querySelector('.subsubmenu:hover')
// 			) {
// 				setIsCategoriesOpen(false);
// 				setOpenSubMenu(null);
// 				setOpenSubSubMenu(null);
// 			}
// 		}, 200);
// 	};

// 	const handleSubMenuMouseLeave = () => {
// 		setTimeout(() => {
// 			if (!document.querySelector('.submenu:hover') && !document.querySelector('.subsubmenu:hover')) {
// 				setOpenSubMenu(null);
// 				setOpenSubSubMenu(null);
// 			}
// 		}, 200);
// 	};

// 	const handleSubSubMenuMouseLeave = () => {
// 		setTimeout(() => {
// 			if (!document.querySelector('.subsubmenu:hover')) {
// 				setOpenSubSubMenu(null);
// 			}
// 		}, 200);
// 	};

// 	useEffect(() => {
// 		const handleClickOutside = (event) => {
// 			if (
// 				categoriesDropdownRef.current &&
// 				!categoriesDropdownRef.current.contains(event.target)
// 			) {
// 				setIsCategoriesOpen(false);
// 				setOpenSubMenu(null);
// 				setOpenSubSubMenu(null);
// 			}
// 			if (
// 				profileDropdownRef.current &&
// 				!profileDropdownRef.current.contains(event.target)
// 			) {
// 				setIsProfileMenuOpen(false);
// 			}
// 		};

// 		document.addEventListener('mousedown', handleClickOutside);
// 		return () => {
// 			document.removeEventListener('mousedown', handleClickOutside);
// 		};
// 	}, []);

// 	const handleLogout = () => {
// 		removeAuthToken();
// 		setToken(null);
// 		setIsSidebarOpen(false);
// 		setIsProfileMenuOpen(false);
// 		toast.success("Logged out successfully");
// 		setTimeout(() => {
// 			window.location.href = "/";
// 		}, 300);
// 	};

// 	const isActiveLink = (path) => currentPath === path ? 'active' : '';

// 	useEffect(() => {
// 		const fetchCategories = async () => {
// 			try {
// 				setLoadingCategories(true);
// 				const data = await getCategoriesMenu();
// 				setCategoriesData(data);
// 				setLoadingCategories(false);
// 			} catch (error) {
// 				setCategoriesError(error);
// 				setLoadingCategories(false);
// 			}
// 		};

// 		fetchCategories();
// 	}, []);

// 	const getUserInitials = (firstName, lastName) => {
// 		let initials = '';
// 		if (firstName?.trim()) initials += firstName.trim()[0].toUpperCase();
// 		if (lastName?.trim()) initials += lastName.trim()[0].toUpperCase();
// 		return initials || 'U';
// 	};

// 	const renderSubSubMenu = (subsubcategories, parentUrl) => {
// 		return (
// 			<div
// 				className="subsubmenu"
// 				onMouseEnter={() => setOpenSubSubMenu(parentUrl)}
// 				onMouseLeave={handleSubSubMenuMouseLeave}
// 			>
// 				{subsubcategories.map((subsubcategory) => (
// 					<Link
// 						key={subsubcategory.id}
// 						to={`/categories/${subsubcategory.url}`}
// 						className="submenu-item"
// 						onClick={() => {
// 							setIsCategoriesOpen(false);
// 							setOpenSubMenu(null);
// 							setOpenSubSubMenu(null);
// 						}}
// 					>
// 						{subsubcategory.name}
// 					</Link>
// 				))}
// 			</div>
// 		);
// 	};

// 	return (
// 		<nav className="header">
// 			<div className="header-container custom-container-side">
// 				<div className="header-left">
// 					<div className="header-logo">
// 						<Link to="/">
// 							<img src={logostelmart} alt="Logo Stelmart" />
// 						</Link>
// 					</div>
// 				</div>

// 				<div className="header-hamburger">
// 					<GiHamburgerMenu className="hamburger-icon" onClick={toggleSidebar} />
// 				</div>

// 				<div className="header-center font-poppins">
// 					<ul className="header-links">
// 						<li><Link to="/" className={isActiveLink('/')}>HOME</Link></li>
// 						<li><Link to="/about-us" className={isActiveLink('/about-us')}>ABOUT US</Link></li>
// 						<li
// 							className="nav-item dropdown"
// 							ref={categoriesDropdownRef}
// 							onMouseEnter={!isMobileView ? () => setIsCategoriesOpen(true) : undefined}
// 							onMouseLeave={!isMobileView ? handleCategoriesMouseLeave : undefined}
// 						>
// 							{isMobileView ? (
// 								<Link
// 									to="/category-search"
// 									className={`nav-link header-links space-header ${isActiveLink('/categories')}`}
// 								>
// 									CATEGORIES
// 								</Link>
// 							) : (
// 								<>
// 									<div
// 										className={`nav-link header-links dropdown-toggle space-header ${isActiveLink('/categories')}`}
// 										onClick={(e) => {
// 											e.stopPropagation();
// 											setIsCategoriesOpen(!isCategoriesOpen);
// 										}}
// 									>
// 										CATEGORIES{' '}
// 										{isCategoriesOpen ? (
// 											<FaChevronUp className="dropdown-icon-c" />
// 										) : (
// 											<FaChevronDown className="dropdown-icon-c" />
// 										)}
// 									</div>
// 									{isCategoriesOpen && (
// 										<div
// 											className="dropdown-menu-c"
// 											onMouseEnter={() => setIsCategoriesOpen(true)}
// 											onMouseLeave={handleCategoriesMouseLeave}
// 										>
// 											{(loadingCategories || categoriesError) ? (
// 												<div className="dropdown-item-c"></div>
// 											) : (
// 												categoriesData.map((category) => (
// 													<div
// 														key={category.id}
// 														className={`dropdown-item-c ${category.subcategories.length ? 'with-submenu' : ''}`}
// 														onClick={() => {
// 															if (!category.subcategories.length) {
// 																navigate(`/categories/${category.url}`);
// 																setIsCategoriesOpen(false);
// 															}
// 														}}
// 														onMouseEnter={() => {
// 															if (category.subcategories.length) {
// 																setOpenSubMenu(category.id);
// 															}
// 														}}
// 														onMouseLeave={() => {
// 															if (category.subcategories.length && !document.querySelector('.submenu:hover')) {
// 																setOpenSubMenu(null);
// 															}
// 														}}
// 													>
// 														<div className="submenu-container">
// 															{category.name}
// 															{category.subcategories.length > 0 && (
// 																<FaChevronRight className="submenu-icon" />
// 															)}
// 														</div>

// 														{openSubMenu === category.id && category.subcategories.length > 0 && (
// 															<div
// 																className="submenu"
// 																onMouseEnter={() => setOpenSubMenu(category.id)}
// 																onMouseLeave={handleSubMenuMouseLeave}
// 															>
// 																{category.subcategories.map((subcategory) => (
// 																	<div
// 																		key={subcategory.id}
// 																		className={`submenu-item ${subcategory.subcategories?.length ? 'with-subsubmenu' : ''}`}
// 																		onClick={(e) => {
// 																			if (!subcategory.subcategories?.length) {
// 																				navigate(`/categories/${subcategory.url}`);
// 																				setIsCategoriesOpen(false);
// 																				setOpenSubMenu(null);
// 																			} else {
// 																				e.stopPropagation();
// 																			}
// 																		}}
// 																		onMouseEnter={() => {
// 																			if (subcategory.subcategories?.length) {
// 																				setOpenSubSubMenu(subcategory.id);
// 																			}
// 																		}}
// 																		onMouseLeave={() => {
// 																			if (subcategory.subcategories?.length && !document.querySelector('.subsubmenu:hover')) {
// 																				setOpenSubSubMenu(null);
// 																			}
// 																		}}
// 																	>
// 																		<div className="subsubmenu-container">
// 																			{subcategory.name}
// 																			{subcategory.subcategories?.length > 0 && (
// 																				<FaChevronRight className="subsubmenu-icon" />
// 																			)}
// 																		</div>
// 																		{openSubSubMenu === subcategory.id && subcategory.subcategories?.length > 0 && (
// 																			renderSubSubMenu(subcategory.subcategories, subcategory.id)
// 																		)}
// 																	</div>
// 																))}
// 															</div>
// 														)}
// 													</div>
// 												))
// 											)}
// 										</div>
// 									)}
// 								</>
// 							)}
// 						</li>
// 						<li><Link to="/financial-services" className={isActiveLink('/financial-services')}>FINANCIAL SERVICES</Link></li>
// 						<li><Link to="/blogs" className={isActiveLink('/blogs')}>BLOGS</Link></li>
// 						<li><Link to="/faqs" className={isActiveLink('/faqs')}>FAQ</Link></li>
// 						{token && <li><Link to="/dashboard" className={isActiveLink('/dashboard')}>DASHBOARD</Link></li>}
// 					</ul>
// 				</div>

// 				<div className="header-right">
// 					{token ? (
// 						<div className="profile-container">
// 							<div className="profile-menu">
// 								<div className="menu-icon" onClick={toggleProfileMenu}>
// 									<div className="menu-line"></div>
// 									<div className="menu-line"></div>
// 									<div className="menu-line"></div>
// 								</div>

// 								<div className="profile-image">
// 									{storedUserData?.image ? (
// 										<img src={storedUserData.image} alt="User" className="user-avatar" />
// 									) : (
// 										<div className="user-initials-header">
// 											{getUserInitials(storedUserData?.name, '')}
// 										</div>
// 									)}
// 									<span className="alert-badge">!</span>
// 								</div>
// 							</div>
// 							{isProfileMenuOpen && (
// 								<div className="profile-dropdown" ref={profileDropdownRef}>
// 									{storedUserData?.userType === 'seller' ? (
// 										<Link
// 											to="/seller-business"
// 											onClick={() => setIsProfileMenuOpen(false)}
// 											className={isActiveLink('/seller-business')}
// 											style={currentPath === '/seller-business' ? { color: '#ffba00' } : {}}
// 										>
// 											<LuBriefcaseBusiness className="icon" />
// 											Seller Business
// 										</Link>
// 									) : (
// 										<Link
// 											to="/business"
// 											onClick={() => setIsProfileMenuOpen(false)}
// 											className={isActiveLink('/business')}
// 											style={currentPath === '/business' ? { color: '#ffba00' } : {}}
// 										>
// 											<LuBriefcaseBusiness className="icon" />
// 											My Business
// 										</Link>
// 									)}
// 									<Link
// 										to="/address"
// 										onClick={() => setIsProfileMenuOpen(false)}
// 										className={isActiveLink('/address')}
// 										style={currentPath === '/address' ? { color: '#ffba00' } : {}}
// 									>
// 										<IoLocationOutline className="icon" />
// 										My Address
// 									</Link>
// 									<Link
// 										to="/setting"
// 										onClick={() => setIsProfileMenuOpen(false)}
// 										className={isActiveLink('/setting')}
// 										style={currentPath === '/setting' ? { color: '#ffba00' } : {}}
// 									>
// 										<CiSettings className="icon" />
// 										Settings
// 									</Link>
// 									<Link to="/" onClick={handleLogout}>
// 										<BiLogOutCircle className="icon" />
// 										Logout
// 									</Link>
// 								</div>
// 							)}
// 						</div>
// 					) : (
// 						<Link
// 							to="/contact"
// 							className="header-contact font-merriweather"
// 							onClick={(e) => {
// 								e.preventDefault();
// 								togglePopup();
// 							}}
// 						>
// 							GET IN TOUCH
// 						</Link>
// 					)}
// 				</div>
// 			</div>

// 			{isSidebarOpen && (
// 				<div className="sidebar">
// 					<IoClose className="close-sidebar-icon" onClick={toggleSidebar} />
// 					<ul className="sidebar-links">
// 						<li><Link to="/" className={isActiveLink('/')} onClick={toggleSidebar}>HOME</Link></li>
// 						<li>
// 							<Link
// 								to="/category-search"
// 								className={isActiveLink('/categories')}
// 								onClick={toggleSidebar}
// 							>
// 								CATEGORIES
// 							</Link>
// 						</li>
// 						<li><Link to="/about-us" className={isActiveLink('/about-us')} onClick={toggleSidebar}>ABOUT US</Link></li>
// 						<li><Link to="/financial-services" className={isActiveLink('/financial-services')} onClick={toggleSidebar}>FINANCIAL SERVICES</Link></li>
// 						<li><Link to="/blogs" className={isActiveLink('/blogs')} onClick={toggleSidebar}>BLOGS</Link></li>
// 						<li><Link to="/faqs" className={isActiveLink('/faqs')} onClick={toggleSidebar}>FAQ</Link></li>
// 						{token && <li><Link to="/dashboard" className={isActiveLink('/dashboard')} onClick={toggleSidebar}>DASHBOARD</Link></li>}
// 						<li><Link to="#contact" className={isActiveLink('/contact')} onClick={toggleSidebar}>GET IN TOUCH</Link></li>
// 						{token && (
// 							<li className="logout" onClick={() => {
// 								handleLogout();
// 								toggleSidebar();
// 							}}>
// 								<BiLogOutCircle className="icon" />
// 								LOGOUT
// 							</li>
// 						)}
// 					</ul>
// 					{token && (
// 						<div className="sidebar-login-register">
// 							<Link to="/dashboard" className="navbar-login font-poppins" onClick={toggleSidebar}>
// 								<RiAccountCircleLine className="navbar-icon" />
// 								MY ACCOUNT
// 							</Link>
// 						</div>
// 					)}
// 					{!token && (
// 						<div className="sidebar-login-register">
// 							<button className="navbar-login font-poppins" onClick={() => {
// 								toggleModal();
// 								toggleSidebar();
// 							}}>
// 								<RiAccountCircleLine className="navbar-icon" />
// 								Login/Register
// 							</button>
// 						</div>
// 					)}
// 				</div>
// 			)}

// 			<LoginModal
// 				isOpen={isModalOpen}
// 				onClose={toggleModal}
// 				onLoginSuccess={() => {
// 					setToken(getAuthToken());
// 					setIsModalOpen(false);
// 				}}
// 			/>

// 			{isPopupOpen && (
// 				<div className="popup">
// 					<div className="popup-content">
// 						<IoClose className="close-popup-icon" onClick={togglePopup} />
// 						<h2 className="popup-title font-merriweather"> <FaHeadphonesAlt /> Connect with us</h2>
// 						<div className="contact-card">
// 							<div className="contact-item">
// 								<div className="contact-icon-circle">
// 									<IoCall className="contact-icon" />
// 								</div>
// 								<div className="contact-details font-lato">
// 									<p className="contact-title">Call us</p>
// 									<p className="contact-info">
// 										<a href="tel:+917011588280">+91 7011588280</a>
// 									</p>
// 									<p className="contact-subinfo">Mon-Fri | 10am to 7pm</p>
// 								</div>
// 							</div>
// 							<div className="contact-item">
// 								<div className="contact-icon-circle">
// 									<MdEmail className="contact-icon" />
// 								</div>
// 								<div className="contact-details font-lato">
// 									<p className="contact-title">Write to us</p>
// 									<p className="contact-info">
// 										<a href="mailto:info@stelmart.co.in">info@stelmart.co.in</a>
// 									</p>
// 								</div>
// 							</div>
// 							<button className="help-support-button" onClick={handleHelpSupportClick}>
// 								Help & Support
// 							</button>
// 						</div>
// 					</div>
// 				</div>
// 			)}
// 		</nav>
// 	);
// };

// export default Header;